import { ComponentConfig } from "@measured/puck"
import { Button, Modal } from "antd"
import { useState } from "react"
import { configs, DefaultImage, Media, MediaUpload } from "../../../../external-components"
import { FooterProps, RenderCareersFooter } from "./RenderConfig"

const ImageCard = ({ value, onChange }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)
  const [url, setUrl] = useState(value)
  const openModal = () => {
    setIsModalOpen(true)
  }

  const handleSelectMedia = (media: { url: string }) => {
    setUrl(media.url)
    onChange(media.url)
    setIsModalOpen(false)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div>
      <div className="flex flex-col gap-2">
        <input type="text" value={url} onChange={e => onChange(e.target.value)} placeholder="Logo URL" readOnly />
        <div className="relative cursor-pointer group" onClick={() => openModal()}>
          <img
            src={url ? `${configs.API_URL}${url}` : DefaultImage}
            alt="Logo"
            className="rounded-lg max-h-96 cursor-pointer transition duration-300 ease-in-out group-hover:blur-sm overflow-hidden"
          />
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 ease-in-out">
            <span className="text-white text-3xl font-semibold drop-shadow-md">Change media</span>
          </div>
        </div>

        <Button
          onClick={() => openModal()}
          type="default"
          variant="outlined"
          className="bg-blue text-white p-4 border-[1px] border-blue rounded-[3px] hover:bg-blue-800 hover:text-white duration-300 my-2"
        >
          Select Image
        </Button>
      </div>
      <Modal
        open={isModalOpen}
        title={<span className="ml-4">Select Media</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div className="ml-4 mt-5">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{
              backgroundColor: isChooseMedia ? "blue" : "initial",
              color: isChooseMedia ? "white" : "initial",
            }}
          >
            Select Media
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            Upload Media
          </Button>
        </div>

        <div>
          {isChooseMedia ? (
            <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
          ) : (
            <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}

export const CareersFooter: ComponentConfig<FooterProps> = {
  label: "Careers | Footer",
  fields: {
    className: { type: "text", label: "Class Name" },
    logo: { label: "Logo", type: "custom", render: props => <ImageCard {...props} /> },
    nameCompany: { type: "text", label: "Name Company" },
    branchCompany: {
      type: "array",
      label: "Branch Company",
      arrayFields: {
        name: { type: "text", label: "Name" },
        address: { type: "text", label: "Address" },
      },
    },
    contact: {
      type: "array",
      label: "Contact",
      arrayFields: {
        icon: { label: "Icon", type: "custom", render: props => <ImageCard {...props} /> },
        label: { type: "text", label: "label" },
        url: { type: "text", label: "URL" },
      },
    },
    introduce: {
      label: "Introduce",
      type: "object",
      objectFields: {
        label: { type: "text", label: "Label" },
        item: {
          type: "array",
          arrayFields: {
            label: { type: "text", label: "Label" },
            url: { type: "text", label: "URL" },
          },
        },
      },
    },
    followUs: {
      label: "Follow Us",
      type: "object",
      objectFields: {
        label: { type: "text", label: "Label" },
        item: {
          type: "array",
          arrayFields: {
            icon: { label: "Icon", type: "custom", render: props => <ImageCard {...props} /> },
            url: { type: "text", label: "URL" },
          },
        },
      },
    },
  },
  defaultProps: {
    className: "",
    nameCompany: "Công ty TNHH Skylink Group",
    branchCompany: [
      {
        name: "Trụ sở chính",
        address:
          "Tòa nhà Cantavil Premier Building, đường Song Hành - Xa Lộ Hà Nội, phường An Phú, TP. Thủ Đức, TP. HCM",
      },
      {
        name: "Cơ sở 1",
        address: "Số 12, đường 7A, Phường An phú, TP.Thủ Đức, TP.HCM.",
      },
      {
        name: "Cơ sở 2",
        address: "15 đường 54, Phường Thảo Điền, TP. Thủ Đức, TP.HCM.",
      },
      {
        name: "Cơ sở 3",
        address: "Unit 2202, 22/F., Causeway Bay Plaza I, 489 Hennessy Road, Causeway Bay, Hong Kong.",
      },
    ],
    contact: [
      {
        icon: "",
        label: "contact@skylink.vn",
        url: "mailto:contact@skylink.vn",
      },
      {
        icon: "",
        label: "Phone: (028) 6254 9999",
        url: "tel:0286254 9999",
      },
    ],
    introduce: {
      label: "Giới thiệu",
      item: [
        {
          label: "Giới thiệu",
          url: "/",
        },
        {
          label: "Về Skylink",
          url: "/ve-skylink-group/",
        },
        {
          label: "Văn hóa Skylink",
          url: "/van-hoa-skylink/",
        },
        {
          label: "Tuyển dụng",
          url: "/skylink-tuyen-dung",
        },
        {
          label: "Tin tức",
          url: "/tin-tuc/",
        },
      ],
    },
    followUs: {
      label: "THEO DÕI CHÚNG TÔI TẠI",
      item: [
        {
          icon: "",
          url: "https://www.facebook.com/skylinkvn",
        },
        {
          icon: "",
          url: "https://www.linkedin.com/company/skylinkvn",
        },
        {
          icon: "",
          url: "https://www.youtube.com/channel/UCb4Q7Jz2vX7e8Q8v6U8bX2w",
        },
      ],
    },
  },
  ...RenderCareersFooter,
}
